<div class="container">

	<div class="grid">
		<div class="col-12">
			<h3>Venda Direta</h3>
		</div>

		<div class="col-12">
			<span>Digite os chassis:</span>
			<textarea pInputTextarea [(ngModel)]="chassis" [rows]="5" [cols]="30" placeholder="chassis"></textarea>
		</div>		  

		<div class="col-12">
			<button pButton type="button" (click)="buttonAddChassis()" icon="pi pi-plus" iconPos="left">
				{{ 'TRANSLATE.ADD' | translate }}
			</button>
			<button pButton type="button" (click)="buttonClean()" icon="pi pi-trash" iconPos="left" class="app-clean-button">
				{{ 'TRANSLATE.CLEAN' | translate }}
			</button>
			<button pButton type="button" (click)="buttonNextWindow()" icon="pi pi-angle-double-right" iconPos="right" class="ui-button-success">
				{{ 'TRANSLATE.ADVANCE' | translate }}
			</button>
		</div>
	</div>

	<div class="grid">
		<div class="col-12">
			<p-table #tabela selectionMode="single" [value]="vinValidateList">
				<ng-template pTemplate="emptymessage">
			  		<tr>
						<td colspan="7">
							{{ 'TRANSLATE.NO.CHASSIS.FOUND' | translate }}
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 200px;">Chassi</th>
						<th style="width: 150px;">Inìcio da Garantia</th>
						<th style="width: 100px;">Ano Modelo</th>
						<th>Linha do Veículo</th>
						<th style="width: 140px;">Sistema</th>
						<th style="width: 80px;">Status</th>
						<th style="width: 80px;">Ações</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-vinValidate>
					<tr>
						<td style="text-align: center;">{{vinValidate.vin}}</td>
						<td style="text-align: center;">{{vinValidate.warrantyStartDate | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
						<td style="text-align: center;">{{vinValidate.modelYear}}</td>
						<td style="text-align: center;">{{vinValidate.vehicleLine}} {{vinValidate.errorMessage | translate}}</td>
						<td style="text-align: center;">{{vinValidate.system}}</td>
						<td style="text-align: center;">
							<span [hidden]="vinValidate.validated !== 0">
								<i class="pi pi-check-circle" style="color: #00b09b ; font-size: 2em;" ></i>
							</span>
							<span [hidden]="vinValidate.validated !== 1">
								<i class="pi pi-times-circle" style="color: #c3002f ; font-size: 2em;" ></i>
							</span>
							<span [hidden]="vinValidate.validated !== 2">
								<i class="pi pi-exclamation-triangle" style="color: #FFFF00 ; font-size: 2em;" ></i>
							</span>							
						</td>
						<td style="text-align: center;">
							<button pButton class="ui-button-danger" type="button" (click)="buttonRemoveChassiList(vinValidate)" icon="pi pi-trash">{{ 'TRANSLATE.DELETE' | translate }}</button>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

</div>